import Image from './Image';

export default Image;



// WEBPACK FOOTER //
// ./src/components/Image/index.tsx